// extracted by mini-css-extract-plugin
module.exports = {"appointmentCardContainer":"AppointmentCard_appointmentCardContainer__3X3iC","acDateBig":"AppointmentCard_acDateBig__2hJP4","acContent":"AppointmentCard_acContent__fmN3p"};